<template>
  <div class="home">
    <carousel></carousel>

    <v-row>
      <v-container>
        <v-row class="justify-center">
          <v-col class="col-12 col-md-6 col-lg-5">
            <v-card color="#e8fffd" class="ma-2 pr-4 pl-10 rounded-pill">
              <v-row>
                <v-col>
                  <v-text-field
                    hide-details
                    color="deep-orange"
                    label="Search Tour Destination"
                  ></v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-btn
                    block
                    large
                    color="#F0807F"
                    height="100%"
                    dark
                    depressed
                    rounded
                    >Search</v-btn
                  >
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-container>

      <v-col cols="12">
        <paket-rekom></paket-rekom>
      </v-col>

      <v-container style="padding: 0">
        <v-col cols="12" sm="12" class="p-0 m-0">
          <v-card class="mx-auto">
            <v-img
              class="white--text align-end"
              height="300px"
              src="https://images.unsplash.com/photo-1604238375869-8fa40deb74a5?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1534&q=80"
            >
              <v-card-title>Top 10 Australian beaches</v-card-title>
            </v-img>
          </v-card>
        </v-col>
      </v-container>
    </v-row>
  </div>
</template>
<script>
// @ is an alias to /src
import Carousel from "@/components/Carousel";
import PaketRekom from "@/components/PaketRekom";

export default {
  name: "Home",
  components: {
    Carousel,
    PaketRekom
  }
};
</script>
